import { useStockCost } from "@erp/shared/components/ui/Document/_composable/useStockCost";
import { defineStore } from "pinia";
export const useObtainStockCostStore = defineStore("useObtainStockCostStore", useStockCost);
